import styled from "styled-components";

export const EyebrowTag = styled.span`
  display: inline-block;
  width: fit-content;
  padding: 0.375rem 1rem;
  border: 1px solid ${(props) => props.theme.palette.redesign.black}33;
  border-radius: 9999px;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 500;
  font-size: 0.6875rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${(props) => props.theme.palette.redesign.black};
  background-color: ${(props) => props.theme.palette.redesign.pink || "transparent"};
  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 0.8125rem;
    padding: 0.5rem 1.25rem;
  }
`;
